export class GenericLookup {
    public id: any;
    public name: any;
    public description: any;
    public isSelected: boolean = false;
}

// tslint:disable-next-line:max-classes-per-file
export class CandidatePortalClientCommonInfo {

    public radius: number = 0;
    public latitude: number = 0.0;
    public longitude: number = 0.0;
    public companyCode: string = '';
    public referralCode: string = '';

}
